
export const convertS3UrlToCDN = (url: string) => {
  return url.replace(
    "brandclub-images.s3.us-west-2.amazonaws.com",
    "media.brandclub.com"
  );
};
